import clsx from "clsx";
import * as React from "react";

import * as PropTypes from "../prop-types";
import { spsGlobalPropTypes } from "../util";

const propsDoc = {};

const propTypes = {
    ...spsGlobalPropTypes
};

export type SpsSummaryListExpansionProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsSummaryListExpansion(props: SpsSummaryListExpansionProps) {
    const {
        children,
        className,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const classes = clsx(
        unsafelyReplaceClassName || "sps-content-row__expansion",
        className,
    );

    return (
        <div className={classes}
            {...rest}
            data-testid={`${testId}__expansion`}
        >
            {children}
        </div>
    );
}

Object.assign(SpsSummaryListExpansion, {
    props: propsDoc,
    propTypes,
    displayName: "SpsSummaryListExpansion"
});
